import React from "react";

const GetMenuItem = (label, key, icon, children) => {
    return {key, icon, children, label}
}

export default GetMenuItem;